import {BlockControls,  store as blockEditorStore } from '@wordpress/block-editor';
import { useEffect, useRef,memo } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { GrRefresh } from "react-icons/gr";
import noimagelong from "../../../../../inc/assets/img/no-image-long.png";
import SliderToolbar from './sliderToolbar';
import {SwiperInit} from './swiper-init';
import { subscribeSliderUpdate } from './subscribeSliderUpdate';
import ChildeBlock from './childeblock';
import { createBlock } from '@wordpress/blocks';
import { useDispatch, useSelect } from '@wordpress/data';
import { store as noticesStore } from '@wordpress/notices';
import {CopyPasteStyles} from '@vayu-blocks';

const DEFAULT_BLOCK = 'vayu-blocks/advance-container';
const DEFAULT_BLOCK_ATTRIBUTES = {
    image: noimagelong,
    overlayshow: false,
    overlaycolor: '#abb8c3',
    contentani: false,
};

const Slider = memo(({ clientId, attributes, setAttributes}) => {

    const sliderRef = useRef(null);

    useEffect(() => {

        if (!sliderRef.current) return;        
        const options = { ...attributes };

        let slider = SwiperInit(sliderRef.current, options);

        setAttributes({ slideslength: slider.slides.length });

        const unsubscribeSliderUpdate = subscribeSliderUpdate(
            slider,
            clientId,
            sliderRef.current,
            options
        );

        return () => {
            unsubscribeSliderUpdate();
            slider.destroy();
        };
    }, [attributes, clientId]);

    const { insertBlock, selectBlock } = useDispatch(blockEditorStore);

    const innerBlocks = useSelect(
        (select) => select(blockEditorStore).getBlock(clientId)?.innerBlocks || []
    );

    const { createNotice } = useDispatch(noticesStore);

    function getTargetBlock(clientId) {
        let target = document.querySelector(`[data-block="${clientId}"]`);
        if (target) return target;
        const iframe = document.querySelector('iframe[name="editor-canvas"]') || document.querySelector('iframe'); // fallback
        if (iframe && iframe.contentDocument) {
            target = iframe.contentDocument.querySelector(`[data-block="${clientId}"]`);
            if (target) return target;
        }
        return null;
    }

    function animateTargetBlock() {
        const target = getTargetBlock(clientId);

        if (target) {
            setTimeout(() => {
                target.classList.add('vb-slide-added');

                setTimeout(() => {
                    target.classList.remove('vb-slide-added');
                }, 2000);
            }, 0);
        }
    }

    // Create a Slide block and insert it.
    const addSlide = () => {

        animateTargetBlock();

        const block = createBlock('vayu-blocks/advance-container', { className: 'swiper-slide', 
            advPadding: {
                Desktop: '0px',
                Tablet: '0px',
                Mobile: '0px'
            } 
        }, [
            createBlock('vayu-blocks/image', {
                ...DEFAULT_BLOCK_ATTRIBUTES
            })
        ]);

        insertBlock(block, innerBlocks.length, clientId, false);

        // 👇 After a delay, select the newly added block and go to that slide
        setTimeout(() => {
            // selectBlock(newSlideBlock.clientId);

            // Go to that slide (ensure Swiper instance exists)
           const swiperInstance = sliderRef.current?.swiper;
            if (swiperInstance) {
                swiperInstance.update(); // 🔁 Recalculate slides
                swiperInstance.slideTo(innerBlocks.length); // 👉 Go to the new one
            }
        }, 200);

        createNotice('success', 'slide added!', {
            isDismissible: true,
            type: 'snackbar',
        });
    };

    const StartSlider = () => {
        const container = sliderRef.current;
        if (!container) return;

        let swiperInstance = container.swiper;

        if (!swiperInstance || !swiperInstance.slides || swiperInstance.slides.length === 0) return;

        // ✅ Get the first slide DOM element
        const firstSlide = swiperInstance.slides[0];

        if (firstSlide) {
            // 🧠 Option 1: Scroll it into view
            firstSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

            // ✅ Option 2 (More forceful): Apply a transform directly
            swiperInstance.wrapperEl.style.transition = 'transform 0.3s ease-in-out';
            swiperInstance.wrapperEl.style.transform = `translate3d(-${firstSlide.offsetLeft}px, 0, 0)`;

            swiperInstance.activeIndex = 0;
            swiperInstance.update();
        }
    };

    return (
        <>
            <BlockControls>
                <SliderToolbar
                    clientId={clientId}
                    DEFAULT_BLOCK_ATTRIBUTES={DEFAULT_BLOCK_ATTRIBUTES}
                    animateTargetBlock={animateTargetBlock}
                    sliderRef={sliderRef}
                />

                <CopyPasteStyles attributes={attributes} setAttributes={setAttributes} blockName={'vayu-blocks/advance-slider'}/>
            </BlockControls>

            <div
                className="swiper mySwiper vayu-blocks-default-border-dashed-slider"
                ref={sliderRef}
            >
                <ChildeBlock clientId={clientId}/>
            </div>

            <div class="vb-slider-button">
                <div class="vb-slider-clearall-button">
                    <button onClick={addSlide} variant="secondary" className="my-custom-add-slide-button">
                        + Add Slide
                    </button>
                </div>

                <div class="vb-slider-clearall-button vb-slider-refresh">
                    <button onClick={StartSlider} variant="secondary" className="my-custom-add-slide-button">
                    <GrRefresh /> Restore
                    </button>
                </div>
            </div>
        </>
    );
});

export default Slider;